import { useContext } from 'react';
import ProjectContext from './ProjectContext';

export const useProjectContext = () => useContext(ProjectContext);
